
export default {
  form: {
    school_group_name: '学校・団体名',
    student_name: '生徒氏名',
    phone_number: '電話番号',
    email: 'メールアドレス',
    content: '問い合わせ内容',
    order_number: '注文番号',
  },
  button: {
    submit: '送信',
  },
  message: {
    success: 'お問い合わせを送信しました。',
    error: 'エラーが発生しました。もう一度お試しください。',
  },
  placeholder: {
    select_order: '注文番号を選択してください',
  },
};
